import CartUpdatedUseCase, { ICartUpdatedPayload } from '~use-cases/CartUpdatedUseCase';
import OffersLoadedUseCase from '~use-cases/OffersLoadedUseCase';
import { diContainer } from './diContainer';
import CartRepository from '~repositories/CartRepository/CartRepository';
import { serviceNames } from '~setup/CartService';
import FetchedCartInfoUseCase from '~use-cases/FetchedCartInfoUseCase';

export default class ServiceBusController {
    public getCart = async () => {
        const cartRepository: CartRepository = diContainer.get(serviceNames.cartRepository);
        await cartRepository.fetchCart();

        return cartRepository?.cart;
    };

    public fetchedCart = () => new FetchedCartInfoUseCase().execute();

    public cartOverlayIconClicked = ({ itemsQty, isMobile }: ICartUpdatedPayload) => {
        const { config } = diContainer.get(serviceNames.config);
        const { drawerCheckoutUrl, redirectToCheckoutOnEmpty, redirectToCheckoutOnMobile } =
            config?.cartConfig || {};

        if (redirectToCheckoutOnMobile && isMobile) {
            return this.redirectToCheckout(drawerCheckoutUrl);
        }
        if (redirectToCheckoutOnEmpty && itemsQty === '0') {
            return this.redirectToCheckout(drawerCheckoutUrl);
        }

        return this.iconClicked();
    };

    private redirectToCheckout = (url: string) => {
        const cartRepository: CartRepository = diContainer.get(serviceNames.cartRepository);
        cartRepository.abortRequest = true;

        window.location.href = url;
    };

    private iconClicked = () => {
        const userOpenProps: ICartUpdatedPayload = {
            newState: true,
            newDisplayState: false,
            isUserEvent: true
        };

        return new CartUpdatedUseCase(userOpenProps).execute();
    };

    public showCartOverlay = async (overlayProps: ICartUpdatedPayload) => {
        const defaultProps: ICartUpdatedPayload = {
            newState: true,
            newDisplayState: true,
            isUserEvent: false
        };

        const cartBadgeClickedUseCase = new CartUpdatedUseCase({
            ...defaultProps,
            ...overlayProps
        });
        await cartBadgeClickedUseCase.execute();
    };

    public onItemAdded = (overlayProps: ICartUpdatedPayload) => {
        const defaultProps: ICartUpdatedPayload = {
            newState: true,
            newDisplayState: true,
            isUserEvent: false
        };

        return new CartUpdatedUseCase({ ...defaultProps, ...overlayProps }).execute();
    };

    public onOffersLoaded = ({ offerCount = 0, displayCartTabOffers = false }) =>
        new OffersLoadedUseCase(offerCount, displayCartTabOffers).execute();

    public onOfferCodeApplied = (overlayProps: ICartUpdatedPayload) => {
        const defaultProps: ICartUpdatedPayload = {
            newState: true,
            newDisplayState: false,
            isUserEvent: false
        };

        return new CartUpdatedUseCase({ ...defaultProps, ...overlayProps }).execute();
    };
}
